import { Button, Link, makeStyles } from '@material-ui/core';
import React from 'react';

// These sit on the dark backdrop, so hover is a translucent white tint
// rather than the ghost button's solid --accent (meant for light surfaces).
const useStyles = makeStyles(() => ({
  root: {
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  },
}));

export interface LinkImageButtonProps {
  imageUrl: string;
  href: string;
  width?: string;
}

export function LinkImageButton({
  href,
  imageUrl,
  width,
}: LinkImageButtonProps) {
  const classes = useStyles();
  return (
    <Link href={href}>
      <Button className={classes.root}>
        <img src={imageUrl} width={width || ''} />
      </Button>
    </Link>
  );
}
